import axios from "axios";
import * as math from "mathjs";
import { signalRIssuerId } from "../Common/Store/CommonSignals";

export const getHighlight = (value, filter) => {
  if (!value) return;
  if (!filter) return value;
  if (value.length === 0) return value;
  if (filter.length === 0) return value;

  let index = value.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase());
  if (index >= 0) {
    let left = value.substr(0, index);
    let right = value.substring(index + filter.length, value.length);
    return (
      <>
        {left}
        <span className="k-highlight-text">{value.substr(index, filter.length)}</span>
        {getHighlight(right, filter)}
      </>
    );
  }
  return value;
};

export function extractVariables(field) {
  const variables = new Set();

  if (field?.properties?.VisibilityRules) {
    field.properties.VisibilityRules.forEach((rule) => {
      const node = math.parse(rule?.expression);
      const mathFunctions = new Set(Object.keys(math));

      node.traverse(function (node) {
        if (node.isSymbolNode && !mathFunctions.has(node.name)) {
          variables.add(node.name);
        }
      });
    });
  }

  if (field?.properties?.Expression) {
    const node = math.parse(field.properties.Expression);
    const mathFunctions = new Set(Object.keys(math));

    node.traverse(function (node) {
      if (node.isSymbolNode && !mathFunctions.has(node.name)) {
        variables.add(node.name);
      }
    });
  }

  if (field?.properties?.ParentFieldName) {
    variables.add(field.properties.ParentFieldName);
  }

  return Array.from(variables);
}

export const deepEqual = (initialValues, currentValues) => {
  if (
    Array.isArray(initialValues) &&
    Array.isArray(currentValues) &&
    initialValues.length === 0 &&
    currentValues.length === 0
  ) {
    return true;
  }
  if ((Array.isArray(initialValues) && initialValues.length === 0) || initialValues === "[]") {
    return currentValues === "" || currentValues === "[]";
  }
  if ((Array.isArray(currentValues) && currentValues.length === 0) || currentValues === "[]") {
    return initialValues === "" || initialValues === "[]";
  }
  return JSON.stringify(initialValues) === JSON.stringify(currentValues);
};

export const handleSignalRTrigger = async (actionType, resourceType, entity) => {
  const signalRObject = {
    IssuerId: signalRIssuerId.value,
    ActionType: actionType,
    ResourceType: resourceType,
    UpdatedEntity: entity,
  };

  //if not development or CI, send signalR message
  if (process.env.NODE_ENV !== "development" && !process.env.CI) {
    await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/SignalR/GenerateSignalRMessage`,
      signalRObject,
      { headers: { "Content-Type": "application/json" } }
    );
  }
};
